export default {"src":"/_next/static/media/idr_points.1272fc12.svg","height":112,"width":103,"blurWidth":0,"blurHeight":0};